<script>
    import Layout from "../../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import Business from '@/services/Business';
    import modalAddCompany from '@/components/modals/customers/modalAddCompany';
    import ModalEditBusinessWall from '@/components/modals/business/modalEditBusinessWall';
    import ModalAddCompanyToBusinessWall from '@/components/modals/business/modalAddCompanyToBusinessWall'
    import BusinessWallMobilePreview from '@/components/business/BusinessWallMobilePreview';
    import Sortable from "sortablejs";
    import Swal from "sweetalert2";

    export default {
        components: {
            Layout,
            PageHeader,
            ModalEditBusinessWall,
            ModalAddCompanyToBusinessWall,
            BusinessWallMobilePreview,
            modalAddCompany,
        },
        page: {
            title: "Business Wall",
            meta: [
                {
                    name: "description",
                    content: appConfig.description,
                },
            ],
        },
        data() {
            return {
                isAuthorized: false,
                error: null,
                filterData: true,
                showMapData: false,
                showMap: false,
                tableData: [],
                title: "Business Wall",
                items: [
                    {
                        text: "Business",
                        href: "/business/companies",
                    },
                    {
                        text: "Business Wall",
                        active: true,
                    },
                ],
                ticketing_client_types:[],
                userStatuses: [],
                filterInput: {
                    name: '',
                    gender: [],
                    company_id: '',
                    userStatus: [],
                },
                companyData: [],
                selectedBusinessWallCompanyDetails:null,
                showModal: false,
                countries: [],
                isBusy: false,
                totalRows: 0,
                currentPage: 1,
                perPage: 10,
                pageOptions: [10, 25, 50, 100],
                filter: null,
                filterOn: [],
                sortBy: "order",
                sortDesc: false,
                sortableInstance: null,
                savingOrder: false,
                fields: [
                    {
                        key: "drag",
                        label: "",
                        thClass: "text-center",
                        tdClass: "text-center",
                    },
                    {
                        key: "name",
                        label: "Company Name",
                        sortable: true,
                    },
                    {
                        key: "website",
                        label: "Website",
                        sortable: true,
                    },
                    {
                        key: "is_highlighted",
                        label: "Is Highlighted",
                        sortable: true,
                    },
                    {
                        key: "order",
                        label: "Order",
                        sortable: true,
                    },
                    {
                        key: "background_color",
                        label: "Background Color",
                        sortable: true,
                    },
                    {
                        key: "logo_url",
                        label: "Logo Image",
                        sortable: true,
                    },
                    "action"
                ],
            };
        },

        computed: {
            sortedTableData() {
                return [...this.tableData].sort((a, b) => {
                    const aHighlighted = Number(a.is_highlighted) === 1;
                    const bHighlighted = Number(b.is_highlighted) === 1;
                    if (aHighlighted !== bHighlighted) {
                        return bHighlighted ? 1 : -1;
                    }
                    return (Number(a.order) || 0) - (Number(b.order) || 0);
                });
            },
            canReorder() {
                return (
                    !this.isBusy &&
                    !this.savingOrder &&
                    !this.filter &&
                    this.sortedTableData.length > 1
                );
            },
        },

        watch: {
            isBusy(isLoading) {
                if (isLoading) {
                    this.destroySortable();
                    return;
                }
                this.$nextTick(() => this.initSortable());
            },
            currentPage() {
                this.$nextTick(() => this.initSortable());
            },
            perPage() {
                this.$nextTick(() => this.initSortable());
            },
            filter() {
                this.$nextTick(() => this.initSortable());
            },
            tableData() {
                this.$nextTick(() => this.initSortable());
            },
        },

        methods: {
            toggleBusy() {
                this.isBusy = !this.isBusy;
            },

            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length;
                this.currentPage = 1;
            },

            modalAddCompanyToBusinessWall(){
                this.$bvModal.show("add_company_to_business_wall");
            },
            openEditBusinessWallModal(businessWallItem) {
                this.selectedBusinessWallCompanyDetails = businessWallItem;
                this.$bvModal.show("edit_business_wall");
            },
            async getBusinessWall(){
                try {

                    this.toggleBusy();
                    // var filters = this.getFilters()
                    const response = await Business.getBusinessWall();

                    this.tableData = response.data.data
                    this.totalRows = this.tableData.length
                    this.currentPage = 1
                    this.filterData = true
                } catch (error) {
                    this.error = error.response.data.error ? error.response.data.error : "";
                    this.tableData = []
                    this.totalRows = 0;
                    this.currentPage = 1;
                    this.filterData = true;
                } finally {
                    this.toggleBusy();
                    this.$nextTick(() => this.initSortable());
                }
            },
            rowClass(item, type) {
                if (type !== "row") {
                    return null;
                }
                return Number(item.is_highlighted) === 1
                    ? "business-wall-row no-drag"
                    : "business-wall-row";
            },
            destroySortable() {
                if (this.sortableInstance) {
                    this.sortableInstance.destroy();
                    this.sortableInstance = null;
                }
            },
            initSortable() {
                this.destroySortable();

                if (!this.canReorder) {
                    return;
                }

                const tableEl = this.$refs.businessWallTable && this.$refs.businessWallTable.$el;
                const tbody = tableEl && tableEl.querySelector("tbody");
                if (!tbody) {
                    return;
                }

                this.sortableInstance = Sortable.create(tbody, {
                    handle: ".drag-handle",
                    draggable: ".business-wall-row",
                    animation: 150,
                    ghostClass: "sortable-ghost",
                    filter: ".no-drag",
                    preventOnFilter: true,
                    onMove: (evt) => {
                        const highlighted = this.sortedTableData.find(
                            (company) => Number(company.is_highlighted) === 1
                        );
                        if (!highlighted) {
                            return true;
                        }

                        const children = Array.from(evt.from.children);
                        const relatedIndex = children.indexOf(evt.related);
                        const pageStart = (this.currentPage - 1) * this.perPage;
                        const globalRelatedIndex = pageStart + relatedIndex;

                        if (globalRelatedIndex === 0 && !evt.willInsertAfter) {
                            return false;
                        }

                        return true;
                    },
                    onEnd: this.handleSortEnd,
                });
            },
            async handleSortEnd(evt) {
                if (
                    evt.oldIndex == null ||
                    evt.newIndex == null ||
                    evt.oldIndex === evt.newIndex
                ) {
                    return;
                }

                const parent = evt.from;
                if (evt.oldIndex < evt.newIndex) {
                    parent.insertBefore(evt.item, parent.children[evt.oldIndex]);
                } else {
                    parent.insertBefore(evt.item, parent.children[evt.oldIndex + 1]);
                }

                const sorted = [...this.sortedTableData];
                const pageStart = (this.currentPage - 1) * this.perPage;
                const oldGlobalIndex = pageStart + evt.oldIndex;
                const newGlobalIndex = pageStart + evt.newIndex;
                const [moved] = sorted.splice(oldGlobalIndex, 1);
                sorted.splice(newGlobalIndex, 0, moved);

                const newOrder = newGlobalIndex + 1;
                const previousOrder = Number(moved.order) || 0;

                sorted.forEach((item, index) => {
                    item.order = index + 1;
                });
                this.tableData = sorted;

                if (newOrder === previousOrder) {
                    return;
                }

                try {
                    this.savingOrder = true;
                    const response = await Business.updateBusinessWall(moved.company_id, { order: newOrder });
                    const success = response.data && response.data.data && response.data.data.success;

                    if (!success) {
                        const error = response.data?.error || "Failed to update order";
                        throw new Error(error);
                    }

                    await this.getBusinessWall();
                } catch (error) {
                    const message = error?.response?.data?.error || error?.message || "Failed to update order";
                    Swal.fire("Fail!", Array.isArray(message) ? message.join(", ") : message, "warning");
                    await this.getBusinessWall();
                } finally {
                    this.savingOrder = false;
                    this.$nextTick(() => this.initSortable());
                }
            },
            removeCompanyFromBusinessWall(id){
                Swal.fire({
                    title: "Remove company from Business Wall?",
                    text: "This company will be removed!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#34c38f",
                    cancelButtonColor: "#f46a6a",
                    confirmButtonText: "Remove!",
                }).then((result) => {
                    if (result.value) {
                        try {
                            Business.deleteCompanyFromBusinessWall(id)
                                .then((response) => {
                                    const res = response.data ? response.data : false;
                                    const error = response.data.error ? response.data.error : 'Failed';
                                    if(res){
                                        this.getBusinessWall()
                                        Swal.fire("Remove company", "Company is successfully removed!", "success");
                                    }else{
                                        Swal.fire("Fail!", error, "warning");
                                    }
                                })
                        }catch(error){
                            this.error = error.response.data.error ? error.response.data.error : "";
                        }
                    }
                });
            },
            async onToggleHighlight(item) {
                try {
                    const currentHighlighted = this.tableData.find(row => row.is_highlighted === 1);

                    if (currentHighlighted) {
                        const payloadOff = { is_highlighted: 0 };
                        await Business.updateBusinessWall(currentHighlighted.company_id, payloadOff);
                        currentHighlighted.is_highlighted = 0;
                    }

                    if (currentHighlighted && currentHighlighted.company_id === item.company_id) {
                        return;
                    }

                    const payloadOn = { is_highlighted: 1 };
                    await Business.updateBusinessWall(item.company_id, payloadOn);
                    item.is_highlighted = 1;

                } catch (error) {
                    console.error("Error toggling highlight:", error);
                }
            }

        },
        mounted() {
            this.getBusinessWall();
            document.body.classList.add("business-wall-page-active");
        },
        beforeDestroy() {
            this.destroySortable();
            document.body.classList.remove("business-wall-page-active");
        },
        middleware: "authentication",
    };
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items"/>
        <div class="row g-3 business-wall-workspace">
            <div class="col-lg-8">
                <div class="card">
                    <div class="card-body">
                        <div>
                            <a href="javascript:void(0);" class="btn btn-success waves-effect waves-light me-3"
                               @click="modalAddCompanyToBusinessWall">
                                <i class="mdi mdi-plus me-2"></i>
                                Add Company To Business Wall
                            </a>
                        </div>
                        <div class="row mt-2 mb-4">
                            <div class="col d-inline-flex align-items-center">
                                <h4 class="card-title m-0" style="margin-right: 15px !important;">Total Companies: {{totalRows}}</h4>
                            </div>
                        </div>
                        <p v-if="canReorder" class="text-muted small mb-0">
                            Drag rows using the handle to change order.
                        </p>
                        <p v-else-if="filter && sortedTableData.length > 1" class="text-muted small mb-0">
                            Clear search to reorder companies.
                        </p>


                        <div class="row mt-4" v-show="filterData">
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_length" class="dataTables_length">
                                    <label class="d-inline-flex align-items-center">
                                        Show&nbsp;
                                        <b-form-select
                                                v-model="perPage"
                                                size="sm"
                                                :options="pageOptions"
                                        ></b-form-select
                                        >&nbsp;entries
                                    </label>
                                </div>
                            </div>
                            <!-- Search -->
                            <div class="col-sm-12 col-md-6">
                                <div
                                        id="tickets-table_filter"
                                        class="dataTables_filter text-md-end"
                                >
                                    <label class="d-inline-flex align-items-center">
                                        Search:
                                        <b-form-input
                                                v-model="filter"
                                                type="search"
                                                placeholder="Search..."
                                                class="form-control form-control-sm ms-2"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                            <!-- End search -->
                        </div>
                        <!-- Table -->
                        <div class="table-responsive mb-0">
                            <b-table
                                    ref="businessWallTable"
                                    :items="sortedTableData"
                                    :busy="isBusy"
                                    :fields="fields"
                                    responsive="sm"
                                    :per-page="perPage"
                                    :current-page="currentPage"
                                    :sort-by.sync="sortBy"
                                    :sort-desc.sync="sortDesc"
                                    :filter="filter"
                                    :filter-included-fields="filterOn"
                                    :tbody-tr-class="rowClass"
                                    @filtered="onFiltered"
                                    show-empty
                                    empty-text="No Data Found"
                            >
                                <template v-slot:cell(drag)="data">
                                    <span
                                        v-if="canReorder && Number(data.item.is_highlighted) !== 1"
                                        class="drag-handle"
                                        title="Drag to reorder"
                                    >
                                        <i class="uil uil-bars font-size-18 text-muted"></i>
                                    </span>
                                </template>

                                <template v-slot:cell(company_id)="data">
                                    {{ data.item.company_id }}
                                </template>
                                <template v-slot:cell(website)="data">
                                    <a :href="data.item.website">
                                        <span>{{data.item.website}}</span>
                                    </a>
                                </template>
                                <template v-slot:cell(is_highlighted)="data">
                                    <div class="form-check form-switch">
                                        <input
                                                type="checkbox"
                                                class="form-check-input"
                                                :id="'highlight-' + data.item.company_id"
                                                :checked="data.item.is_highlighted === 1"
                                                @click="onToggleHighlight(data.item)"
                                        />
                                    </div>
                                </template>
                                <template v-slot:cell(order)="data">
                                    {{ data.item.order }}
                                </template>
                                <template  v-slot:cell(background_color)="data">
<!--                                    <ul class="list-inline mb-0">-->
<!--                                        <span :style="{ background: data.item.background_color, borderRadius: '5px', padding:'5px' }">Color</span>-->
<!--                                    </ul>-->
                                    <ul class="list-inline mb-0 d-flex" style="gap: 10px;">
                                        <span :style="{ display:'block', width:'20px', height:'20px', background: data.item.background_color,  padding:'5px', border:'1px solid black' }"></span>
                                        <span >{{data.item.background_color}}</span>
                                    </ul>
                                </template>
                                <template v-slot:cell(logo_url)="data">
                                    <div
                                        class="business-wall-table-logo"
                                        :style="{ backgroundColor: data.item.background_color || '#e8edf2' }"
                                    >
                                        <img
                                            v-if="data.item.logo_url"
                                            :src="data.item.logo_url"
                                            :alt="data.item.name"
                                            class="business-wall-table-logo__img"
                                        />
                                    </div>
                                </template>
                                <template v-slot:cell(action)="data">
                                    <ul class="list-inline mb-0">
                                        <li class="list-inline-item">
                                            <a
                                                href="javascript:void(0);"
                                                class="px-2 text-primary"
                                                title="Edit"
                                                @click="openEditBusinessWallModal(data.item)"
                                            >
                                                <i class="uil uil-pen font-size-18"></i>
                                            </a>
                                        </li>
                                        <li class="list-inline-item">
                                            <a href="javascript:void(0);" class="px-2 text-danger" title="Remove Company" @click="removeCompanyFromBusinessWall(data.item.company_id)">
                                                <i class="uil uil-trash-alt font-size-18"></i>
                                            </a>
                                        </li>
                                    </ul>
                                </template>
                                <template #table-busy>                              
                                    <div  class="text-center my-4">
                                        <b-spinner variant="primary" class="align-middle"></b-spinner>
                                        <strong class="ms-2">Loading...</strong>
                                     </div>
                                </template>

                            </b-table>
                        </div>
                        <div class="row" v-show="filterData">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-end">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination
                                                v-model="currentPage"
                                                :total-rows="totalRows"
                                                :per-page="perPage"
                                        ></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 business-wall-preview-col">
                <div class="card business-wall-preview-card">
                    <div class="card-body">
                        <BusinessWallMobilePreview
                            :companies="tableData"
                            :loading="isBusy"
                        />
                    </div>
                </div>
            </div>
        </div>

        <modalAddCompany @onRefresh="getBusinessWall()"></modalAddCompany>
        <ModalEditBusinessWall
            @onRefresh="getBusinessWall()"
            :businessWallCompanyDetails="selectedBusinessWallCompanyDetails"
        />
        <ModalAddCompanyToBusinessWall @onRefresh="getBusinessWall"
          :existing-company-ids="tableData.map(item => item.company_id)"
        ></ModalAddCompanyToBusinessWall>
    </Layout>
</template>

<style scoped>
.drag-handle {
  cursor: move;
}

.business-wall-workspace ::v-deep .sortable-ghost {
  opacity: 0.45;
}

@media (min-width: 992px) {
  .business-wall-workspace {
    align-items: flex-start;
  }

  .business-wall-preview-col {
    position: -webkit-sticky;
    position: sticky;
    top: 5.625rem;
    align-self: flex-start;
    z-index: 2;
  }

  .business-wall-table-logo {
    width: 80px;
    height: 48px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px;
    box-sizing: border-box;
  }

  .business-wall-table-logo__img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
}
</style>

<style>
@media (min-width: 992px) {
  body.business-wall-page-active .main-content {
    overflow: visible;
  }
}
</style>
